const translations = {
  "en": {
    "~Send me a screenshot of your positions page. I'll check which of your funds overlap.~": "~Send me a screenshot of your positions page. I'll check which of your funds overlap.~",
    "~That didn't upload. Your files are still here, try again.~": "~That didn't upload. Your files are still here, try again.~",
    "~Try again~": "~Try again~",
    "~Your Positions or Holdings page, tickers and values visible~": "~Your Positions or Holdings page, tickers and values visible~",
    "Close": "Close",
    "Confirm": "Confirm",
    "CSV export": "CSV export",
    "Drop in whatever you've got — statements, holdings, an advisor's proposal. It stays private, and I'll make sense of it.": "Drop in whatever you've got — statements, holdings, an advisor's proposal. It stays private, and I'll make sense of it.",
    "From your broker app, positions visible": "From your broker app, positions visible",
    "Go back": "Go back",
    "Holdings screenshot": "Holdings screenshot",
    "Monthly or quarterly, last 90 days": "Monthly or quarterly, last 90 days",
    "Positions or transactions export": "Positions or transactions export",
    "Send me a screenshot of your positions page. I'll check which of your funds overlap.": "Send me a screenshot of your positions page. I'll check which of your funds overlap.",
    "Statement PDF": "Statement PDF",
    "That didn't upload. Your files are still here, try again.": "That didn't upload. Your files are still here, try again.",
    "Try again": "Try again",
    "Upload documents": "Upload documents",
    "Upload materials": "Upload materials",
    "Upload what you have": "Upload what you have",
    "What I can read": "What I can read",
    "Your documents": "Your documents",
    "Your Positions or Holdings page, tickers and values visible": "Your Positions or Holdings page, tickers and values visible"
  },
  "zh-tw": {
    "~Send me a screenshot of your positions page. I'll check which of your funds overlap.~": "Send me a screenshot of your positions page. I'll check which of your funds overlap.",
    "~That didn't upload. Your files are still here, try again.~": "無法上傳。您的檔案仍保留於此，請重試。",
    "~Try again~": "Try again",
    "~Your Positions or Holdings page, tickers and values visible~": "Your Positions or Holdings page, tickers and values visible",
    "Close": "關閉",
    "Confirm": "確認",
    "CSV export": "CSV 匯出",
    "Drop in whatever you've got — statements, holdings, an advisor's proposal. It stays private, and I'll make sense of it.": "提供你手頭的任何資料——對帳單、持倉明細或顧問建議書。內容將嚴格保密，我將為你梳理並釐清。",
    "From your broker app, positions visible": "從你的經紀商應用程式，持倉可見",
    "Go back": "返回",
    "Holdings screenshot": "持倉截圖",
    "Monthly or quarterly, last 90 days": "每月或每季，過去 90 天",
    "Positions or transactions export": "部位或交易紀錄匯出",
    "Send me a screenshot of your positions page. I'll check which of your funds overlap.": "請發送您的持倉頁面截圖。我將為您檢查哪些基金有重疊。",
    "Statement PDF": "對帳單 PDF",
    "That didn't upload. Your files are still here, try again.": "上傳失敗。您的檔案仍保留在此，請重試。",
    "Try again": "重試",
    "Upload documents": "上傳檔案",
    "Upload materials": "上傳檔案",
    "Upload what you have": "上傳現有內容",
    "What I can read": "我能閱讀的內容",
    "Your documents": "你的文件",
    "Your Positions or Holdings page, tickers and values visible": "您的持倉或部位頁面，顯示代碼與金額"
  }
};

export default translations;
